import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PagePodMgmt({user}){
  var T=React.useContext(ThemeCtx).T;
  var _pods=useState([]); var pods=_pods[0]; var setPods=_pods[1];
  var _allusers=useState([]); var allusers=_allusers[0]; var setAllUsers=_allusers[1];
  var _showAdd=useState(false); var showAdd=_showAdd[0]; var setShowAdd=_showAdd[1];
  var _form=useState({name:"",lead_id:"",description:""}); var form=_form[0]; var setForm=_form[1];
  var _sel=useState(null); var sel=_sel[0]; var setSel=_sel[1];
  var _msg=useState({text:"",type:""}); var msg=_msg[0]; var setMsg=_msg[1];
  var showMsg=function(text,type){setMsg({text,type});setTimeout(function(){setMsg({text:"",type:""});},4000);};
  var setF=function(k,v){setForm(function(p){var n=Object.assign({},p);n[k]=v;return n;});};
  var inputStyle={width:"100%",padding:"9px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:8,color:T.text,fontSize:13,outline:"none",boxSizing:"border-box"};
  var labelStyle={fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5,display:"block"};
  useEffect(function(){
    api.get("/pods").then(setPods).catch(function(){});
    api.get("/users").then(setAllUsers).catch(function(){});
  },[]);
  var createPod=async function(){
    if(!form.name.trim()){showMsg("Name required","error");return;}
    try{
      var p=await api.post("/pods",form);
      setPods(function(prev){return prev.concat([p]);});
      setShowAdd(false); setForm({name:"",lead_id:"",description:""});
      showMsg("Pod created","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var updatePod=async function(id,updates){
    try{
      var p=await api.patch("/pods/"+id,updates);
      setPods(function(prev){return prev.map(function(x){return x.id===id?Object.assign({},x,p):x;});});
      showMsg("Updated","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var deletePod=async function(id,name){
    if(!window.confirm("Delete pod "+name+"?")) return;
    try{
      await api.delete("/pods/"+id);
      setPods(function(prev){return prev.filter(function(x){return x.id!==id;});});
      showMsg("Deleted","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var leads=allusers.filter(function(u){return ["lead","admin"].includes(u.role);});
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
    msg.text&&React.createElement("div",{style:{background:msg.type==="success"?T.success+"22":T.danger+"22",border:"1px solid "+(msg.type==="success"?T.success:T.danger)+"44",borderRadius:8,padding:"10px 14px",fontSize:13,color:msg.type==="success"?T.success:T.danger}},msg.text),
    React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},
      React.createElement("div",{style:{fontSize:12,color:T.text3}},pods.length+" pods"),
      React.createElement("button",{onClick:function(){setShowAdd(true);},style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600}},"+ New Pod")
    ),
    showAdd&&React.createElement(Modal,{title:"Create Pod",onClose:function(){setShowAdd(false);}},
      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
        [["name","Pod Name"],["description","Description"]].map(function(item){
          return React.createElement("div",{key:item[0]},
            React.createElement("label",{style:labelStyle},item[1]),
            React.createElement("input",{type:"text",value:form[item[0]],onChange:function(e){setF(item[0],e.target.value);},style:inputStyle})
          );
        }),
        React.createElement("div",null,React.createElement("label",{style:labelStyle},"Pod Lead"),
          React.createElement("select",{value:form.lead_id,onChange:function(e){setF("lead_id",e.target.value);},style:inputStyle},
            React.createElement("option",{value:""},"No lead"),
            leads.map(function(u){return React.createElement("option",{key:u.id,value:u.id},u.name+" ("+u.role+")");})
          )
        ),
        React.createElement("button",{onClick:createPod,style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px",cursor:"pointer",fontSize:13,fontWeight:600}},"Create Pod")
      )
    ),
    pods.map(function(pod){
      var exp=sel===pod.id;
      var members=allusers.filter(function(u){return u.pod===pod.name;});
      return React.createElement(Card,{key:pod.id,style:{padding:"14px 16px"}},
        React.createElement("div",{style:{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:10,flexWrap:"wrap"}},
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:14,fontWeight:600,color:T.text,marginBottom:4}},pod.name),
            pod.description&&React.createElement("div",{style:{fontSize:12,color:T.text3,marginBottom:4}},pod.description),
            React.createElement("div",{style:{display:"flex",gap:12,fontSize:12,color:T.text2,flexWrap:"wrap"}},
              React.createElement("span",null,"Lead: ",React.createElement("strong",null,pod.lead_name||"Unassigned")),
              React.createElement("span",null,"Members: ",React.createElement("strong",null,members.length)),
              React.createElement("span",null,"Open vulns: ",React.createElement("strong",{style:{color:Number(pod.open_vulns)>0?T.danger:T.success}},pod.open_vulns||0))
            )
          ),
          React.createElement("div",{style:{display:"flex",gap:6}},
            React.createElement("button",{onClick:function(){setSel(exp?null:pod.id);},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,padding:"5px 10px",cursor:"pointer",fontSize:11}},exp?"Close":"Edit"),
            React.createElement("button",{onClick:function(){deletePod(pod.id,pod.name);},style:{background:T.danger+"22",color:T.danger,border:"1px solid "+T.danger+"44",borderRadius:6,padding:"5px 10px",cursor:"pointer",fontSize:11}},"Delete")
          )
        ),
        exp&&React.createElement("div",{style:{marginTop:12,paddingTop:12,borderTop:"1px solid "+T.border,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:10}},
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Name"),
            React.createElement("input",{type:"text",defaultValue:pod.name,onBlur:function(e){if(e.target.value.trim()&&e.target.value!==pod.name)updatePod(pod.id,{name:e.target.value.trim()});},style:inputStyle})
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Description"),
            React.createElement("input",{type:"text",defaultValue:pod.description||"",onBlur:function(e){updatePod(pod.id,{description:e.target.value});},style:inputStyle})
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Pod Lead"),
            React.createElement("select",{value:pod.lead_id||"",onChange:function(e){updatePod(pod.id,{lead_id:e.target.value||null});},style:inputStyle},
              React.createElement("option",{value:""},"No lead"),
              leads.map(function(u){return React.createElement("option",{key:u.id,value:u.id},u.name);})
            )
          )
        ),
        members.length>0&&React.createElement("div",{style:{marginTop:10,display:"flex",gap:6,flexWrap:"wrap"}},
          members.map(function(m){return React.createElement("div",{key:m.id,style:{background:T.inset,borderRadius:20,padding:"3px 10px",fontSize:11,color:T.text2}},m.name);})
        )
      );
    })
  );
}

